<template>
  <div class="address_bg_style">
    <van-nav-bar left-text="返回" left-arrow @click-left="onClickLeft" />
    <van-address-list
      v-if="address_list.length > 0"
      v-model="chosenAddressId"
      :list="address_list"
      default-tag-text="默认"
      @add="onAdd"
      @edit="onEdit"
    />
    <div v-else class="order_none_style">
      <div class="order_none_inner_style">
        <img src="../assets/img/无订单icon.png" alt="" />
        <div>暂无收货地址</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { Toast } from "vant";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      chosenAddressId: "1",
      address_list: [],
    };
  },
  mounted() {
    let userId = JSON.parse(this.cgmUserVO).userId;
    this.axios
      .get("/cgmAddress/list", {
        params: {
          userId,
        },
      })
      .then((res) => {
        if (res.data.code == 200) {
          this.address_list = res.data.data;
        }
      });
  },
  methods: {
    onAdd() {
      this.$router.push({
        path: "/addressInsert",
      });
    },
    onEdit(item, index) {
      Toast("编辑地址:" + index);
    },
    onClickLeft() {
      this.$router.push({
        path: "/menu",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.order_none_style {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  color: #8a8a8a;
  height: 534px;
}
.order_none_inner_style {
  margin-top: 76px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.address_bg_style {
  background: #f5f6f8;
}
::v-deep .van-address-list__bottom {
  position: unset;
}
::v-deep .van-address-list__bottom {
  margin-top: 40px;
  background: #f5f6f8;
}
::v-deep .van-address-list {
  padding: 12px 12px 40px;
}
</style>